import { toast } from "react-toastify";
import { Controller } from "./Controller";

class Rapid7InventoryController extends Controller {
    constructor() {
        const initialState = {
            assetItems: [],
            softwareItems: [],
            selectedDate: null,
            selectedGroup: "default", // NEW: Track selected group
        };

        super("rapid7inventory", initialState);

        this.registerRoute(
            { path: "/rapid7-inventory", strict: false, exact: true },
            this.onPageLoad
        );
    }

    onPageLoad = () => {
        const today = new Date().toISOString().split("T")[0];
        const group = "default";
        this.fetchInventory(group, today);
    };

    fetchInventory(group, date) {
        this.asyncAction("FETCH_RAPID7_INVENTORY", async () => {
            try {
                const response = await this.ajax(`/rapid7inventory/${group}/${date}`);
                const assetItems = response.assetItems || [];
                const softwareItems = response.softwareItems || [];
                return {
                    assetItems,
                    softwareItems,
                    selectedDate: date,
                    selectedGroup: group
                };
            } catch (error) {
                console.error("Failed to fetch Rapid7 inventory data", error);
                toast.error("Failed to load Rapid7 inventory data.");
                return { assetItems: [], softwareItems: [] };
            }
        });
    }
}
export { Rapid7InventoryController };